import { Reducer } from 'redux';

import { InformationBarrierSettingsActions } from '../../domains/informationBarrierSettings/actions.types';
import { setFulfilled, setPending, setRejected } from '../types';

import { InformationBarrierSettingsLifecycle } from './types';

const initialState: InformationBarrierSettingsLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

const reducer: Reducer<InformationBarrierSettingsLifecycle, InformationBarrierSettingsActions> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'INFORMATION_BARRIER_SETTINGS.EDIT_FULFILLED':
    case 'INFORMATION_BARRIER_SETTINGS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'INFORMATION_BARRIER_SETTINGS.LOAD_PENDING':
      return setPending();
    case 'INFORMATION_BARRIER_SETTINGS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
